// Keep in sync with warehouse-system/workers/src/utils/untestedJustification.js
export const MIN_UNTESTED_REASON_LENGTH = 20;

export function isValidUntestedReason(text) {
  return typeof text === 'string' && text.trim().length >= MIN_UNTESTED_REASON_LENGTH;
}
